export enum AdditionalFormFieldType {
    MEETING = 1,
    NEGOTIATION = 2
}
export enum AdditionalFormFieldType {
    MEETING = 1,
    NEGOTIATION = 2
}
